/**
 * The Worker's base URL. Every app builds this package from source, so the
 * app's own VITE_API_URL is inlined here at build time.
 */
export function apiUrl(): string {
  return import.meta.env.VITE_API_URL as string
}
